<div class="search--omni" *ngIf="result && !showNoResultsfound" [ngClass]="{disabled: readOnly}">
    <ul>
        <li class="search--omni__image">
            <customer-photo [classes]="'mvd_photo'" [customerNumberId]="result.customerNumber"></customer-photo>
        </li>
        <li>
            <a class="search--omni__customer" href="javascript:void(0)" title="Customer Name" (click)="popupCustomerSummaryModal(result.customerNumber)">{{result.customerName}}</a>&nbsp;<a href="javascript:void(0)" title="Open Record Summary" (click)="viewCustomer(result)"><i class="material-icons">open_in_new</i></a>
            <div *ngIf="result.credentialNumberDisplayValue"><b>{{result.credentialNumberDisplayValue}}</b></div>
            <div>{{result.displayAddress}} {{result.postalCode}}</div>
            <div *ngIf="showDob">DOB: {{result.isBiometricRedacted ? '******' : formattedDate}}</div>
            <div class="deceased" *ngIf="result.customerStatusTypeId == customerStatusTypes.Closed.id">Do Not Use This Record</div>
        </li>
        <li class="search--omni__remove">
            <a class="icon--remove" title="Remove" href="javascript:void(0)" (click)="removeCustomer()" *ngIf="allowDelete"></a>
        </li>
    </ul>
</div>

<div class="mvd_alert__validation" *ngIf="showNoResultsfound">
    <div class="mvd_alert__rule">No results found</div>
</div>